var ReactFormal = require('./index.js');

module.exports = ReactFormal.default;